import { InterruptionModel } from '../models/interruptions/interruptionList.model';

export const getErrorsValidationsDates = (list: InterruptionModel[][]) => {
    let errors: string[] = [];

    if (list.length > 1) {
        list.forEach((interr) => {
            interr.forEach((i) => {
                if (i.startDate >= i.endDate) {
                    errors.push('1');
                }
            });
        });
    } else {
        list[0].forEach((interr) => {
            if (interr.startDate >= interr.endDate) {
                errors.push('1');
            }
        });
    }

    return errors;
};
